import { toast } from 'react-toastify';
import uniqueRandom from 'unique-random';

const getUrlExtension = (url) => {
  let ext = url.split(/[#?]/)[0].split('.').pop().trim();
  return ext.toLowerCase();
};
const checkMediaType = (filename, substr) => {
  console.log(filename);
  let preparedExtensions = substr.map((ex) => `(${ex})`);
  return filename.match(new RegExp(preparedExtensions.join('|'), 'i')) !== null;
};

const onCheckDocument = (file) => {
  if (file && file.length > 0) {
    let path = file[0].path;
    if (
      path.indexOf('.png') !== -1 ||
      path.indexOf('.PNG') !== -1 ||
      path.indexOf('.jpg') !== -1 ||
      path.indexOf('.jpeg') !== -1 ||
      path.indexOf('.JPG') !== -1 ||
      path.indexOf('.JPEG') !== -1
    ) {
      return true;
    } else {
      toast.success(
        '🚫 You have uploaded an invalid file format, allowed formats are JPG or PNG only.',
        { autoClose: 5000, position: 'top-center' }
      );
      return false;
    }
  } else {
    toast.error(
      ' 🚫 You have uploaded an invalid file format, allowed formats are JPG or PNG only.',
      { autoClose: 12000, position: 'top-center' }
    );
  }
};

const onCheckExtensionDocument = (file) => {
  if (file && file.length > 0) {
    let path = file[0].path;
    if (
      path.indexOf('.pdf') !== -1 ||
      path.indexOf('.png') !== -1 ||
      path.indexOf('.PNG') !== -1 ||
      path.indexOf('.jpg') !== -1 ||
      path.indexOf('.jpeg') !== -1 ||
      path.indexOf('.JPG') !== -1 ||
      path.indexOf('.JPEG') !== -1
    ) {
      return true;
    } else {
      toast.success(
        '🚫 You have uploaded an invalid file format, allowed formats are JPG or PNG or PDF only.',
        { autoClose: 5000, position: 'top-center' }
      );
      return false;
    }
  } else {
    toast.error(
      ' 🚫 You have uploaded an invalid file format, allowed formats are JPG or PNG or PDF only.',
      { autoClose: 12000, position: 'top-center' }
    );
  }
};
const onCheckHeicDocument = (file) => {
  if (file && file.length > 0) {
    let path = file[0].path;
    if (path.indexOf('.heic') !== -1 || path.indexOf('.heif') !== -1) {
      toast.success(
        '🚫 You have uploaded an invalid file format, allowed formats are JPG or PNG only.',
        { autoClose: 5000, position: 'top-center' }
      );
      return false;
    } else {
      return true;
    }
  } else {
    toast.error(
      ' 🚫 You have uploaded an invalid file format, allowed formats are JPG or PNG only.',
      { autoClose: 12000, position: 'top-center' }
    );
  }
};
const onCheckHeicDocumentAndMp4 = (file) => {
  if (file && file.length > 0) {
    let path = file[0].path;
    if (path.match(/(.jpg)|(.jpeg)|(.png)|(.mp4)|(.pdf)/)) {
      return true;
    } else {
      toast.error(
        '🚫 You have uploaded an invalid file format, allowed formats are JPG, PNG, MP4, PDF.',
        { autoClose: 5000, position: 'top-center' }
      );
      return false;
    }
  } else {
    toast.error(
      ' 🚫 You have uploaded an invalid file format, allowed formats are JPG or PNG or MP4 only.',
      { autoClose: 12000, position: 'top-center' }
    );
  }
};

const generateRandomNumber = () => {
  const randomNumber = uniqueRandom(100000000, 9999999999);
  return randomNumber();
};

const onImageExtensionNotExist = (image) => {
  if (
    image &&
    image !== null &&
    !(
      image.includes('.png') ||
      image.includes('.PNG') ||
      image.includes('.jpg') ||
      image.includes('.JPG') ||
      image.includes('.jpeg') ||
      image.includes('.JPEG') ||
      image.includes('.jfif')
    )
  ) {
    return true;
  } else {
    return false;
  }
};
const onImageExtensionExist = (image) => {
  if (
    image.includes('.png') ||
    image.includes('.PNG') ||
    image.includes('.jpeg') ||
    image.includes('.jpg') ||
    image.includes('.JPEG') ||
    image.includes('.JPG')
  ) {
    return true;
  } else {
    return false;
  }
};

// Todo: Refactor this lmao.
const onUrlImageExtensionExist = (path) => {
  if (
    path.indexOf('.png') !== -1 ||
    path.indexOf('.PNG') !== -1 ||
    path.indexOf('.jpg') !== -1 ||
    path.indexOf('.jpeg') !== -1 ||
    path.indexOf('.JPG') !== -1 ||
    path.indexOf('.JPEG') !== -1
  ) {
    return true;
  } else {
    return false;
  }
};

export const isImage = (url) => {
  const reg = new RegExp(/(.jpg)|(.jpeg)|.(png)/i);
  return reg.test(url);
};

const sortDocumentsList = (documents) => {
  const sortedDocument =
    documents &&
    documents.length > 0 &&
    documents.sort((a, b) => {
      const firstDocumentName = a.name?.toUpperCase();
      const secondDocumentName = b.name?.toUpperCase();

      if (firstDocumentName < secondDocumentName) {
        return -1;
      }
      if (firstDocumentName > secondDocumentName) {
        return 1;
      }
      return 0;
    });
  return sortedDocument;
};

export {
  getUrlExtension,
  checkMediaType,
  onCheckDocument,
  onCheckHeicDocument,
  generateRandomNumber,
  onImageExtensionNotExist,
  onImageExtensionExist,
  onUrlImageExtensionExist,
  onCheckExtensionDocument,
  sortDocumentsList,
  onCheckHeicDocumentAndMp4,
};
